import { simpleProgrammingReducers } from './quickstart-simple.service';

export const QUICKSTART_SIMPLE_REDUCERS = {
  simpleProgramming: simpleProgrammingReducers
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/quickstart-simple.store.ts